import { useForm } from 'react-hook-form';
import { FormInput } from '../../../wrappers/formInput';
import Button from '../../../compopnents/button'
  import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import Styles from "./styles.module.scss";
import { Link } from 'react-router-dom'
import { Icon } from '@iconify/react';
import { useState } from 'react';



export type LoginFormFields = {
  firstName: string;
  lastName: string;
  email: string;
  phone: number;
  password: any;
};

interface Props {
    disabled: any,
    ClickHandler: (event: React.MouseEvent<HTMLButtonElement>) => void    
  }

  const validationSchema = Yup.object({
    email: Yup.string()
      .required("Field is required")
      .email('Please provide a valid email address'),
    password: Yup.string()
      .required("Field is required")
  });

export const LoginForm: React.FC <Props> = ({ClickHandler,disabled}) => {

  const formOptions = { resolver: yupResolver(validationSchema) };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<LoginFormFields>(formOptions);
    
  const [passwordToggle, setPasswordToggle] = useState<boolean>(false)

  
  const onSubmit = (data: any) => {
    ClickHandler(data)

    
  };

  return (
    <form >
      <div className="form-group">
      <FormInput<LoginFormFields>
        id="email"
        type="email"
        name="email"
        size="medium"
        placeholder="Email Address"
        label=""
        register={register}
        errors={errors}
      />
      </div>
      <div className="form-group ">
        <div className='password-filed'>
      <FormInput<LoginFormFields>
        id="password"
        type={passwordToggle ? 'text' : 'password'}
        name="password"
        size="medium"
        placeholder="Password"
        label=""
        register={register}
        errors={errors}
        />
        <Icon icon={passwordToggle ? "mdi:eye-off-outline" : "mdi:eye-outline"} className='eye-icon' onClick={() => setPasswordToggle((prev) => !prev)}/>
        </div>
      </div>
      <div className={Styles.privacyPolicy}>
        By submitting this form, I agree with Ellow's <a href="https://www.ellow.io/privacy-policy">Privacy Policy</a> &&  <a href="https://www.ellow.io/terms-of-service/">Terms and Conditions</a>. 
        I understand I can unsubscribe at any time.
      </div>
      <Button onClick={handleSubmit(onSubmit)} disabled={disabled} type="submit" variant="primary" size="large">Log In</Button>
      <div className={Styles.forgotpassword}>
        <Link to="/forgotpassword">Forgot Password?</Link>
      </div>
    </form>
  );
};

